var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"apex"},[(_vm.data!=[])?_c('apexchart',{attrs:{"options":_vm.chartOptions,"series":_vm.data.series,"type":"area"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }